export const BikeUseEnum = {
  AppDeliver: 'Para realizar entregas de aplicativos.',
  GoToWork: 'Deslocar para o local de trabalho.',
  GoToSchool: 'Deslocar para o local de estudo.',
  TransportKids: 'Levar crianças para escola ou creche.',
  Errands: 'Resolver coisas do dia a dia. Ex: Mercado, lotéricas, banco.',
  Leisure: 'Para passear, lazer.',
};
